import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";

const ContactForm = ({ formData, setFormData, onSubmit, submitting }) => {
  const { t } = useTranslation();

  return (
    <div className="lg:col-span-2">
      <Card className="bg-white border-0 shadow-lg" data-testid="contact-form-card">
        <CardContent className="p-8">
          <h2 className="text-2xl font-bold text-[#3D405B] mb-6 font-['Playfair_Display']">
            {t("contact.form.title")}
          </h2>
          <form onSubmit={onSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Label className="text-[#3D405B] font-medium mb-2 block">{t("contact.form.fullName")}</Label>
                <Input
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder={t("contact.form.namePlaceholder")}
                  required
                  data-testid="contact-name-input"
                  className="bg-[#F4F1DE]/50"
                />
              </div>
              <div>
                <Label className="text-[#3D405B] font-medium mb-2 block">{t("contact.form.email")}</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder={t("contact.form.emailPlaceholder")}
                  required
                  data-testid="contact-email-input"
                  className="bg-[#F4F1DE]/50"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Label className="text-[#3D405B] font-medium mb-2 block">{t("contact.form.phone")}</Label>
                <Input
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder={t("contact.form.phonePlaceholder")}
                  data-testid="contact-phone-input"
                  className="bg-[#F4F1DE]/50"
                />
              </div>
              <div>
                <Label className="text-[#3D405B] font-medium mb-2 block">{t("contact.form.subject")}</Label>
                <Input
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  placeholder={t("contact.form.subjectPlaceholder")}
                  required
                  data-testid="contact-subject-input"
                  className="bg-[#F4F1DE]/50"
                />
              </div>
            </div>

            <div>
              <Label className="text-[#3D405B] font-medium mb-2 block">{t("contact.form.message")}</Label>
              <Textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                placeholder={t("contact.form.messagePlaceholder")}
                required
                data-testid="contact-message-input"
                className="bg-[#F4F1DE]/50 min-h-[150px]"
              />
            </div>

            <Button
              type="submit"
              disabled={submitting}
              data-testid="contact-submit-btn"
              className="w-full bg-[#E07A5F] hover:bg-[#D0694E] text-white py-6 rounded-full text-lg"
            >
              {submitting ? (
                <>
                  <div className="spinner w-5 h-5 mr-2"></div>
                  {t("contact.form.sending")}
                </>
              ) : (
                <>
                  <Send className="w-5 h-5 mr-2" />
                  {t("contact.form.submit")}
                </>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactForm;
